import { Box, Typography } from "@mui/material";

import colors from "../styles/colors/colors";
import fontWeight from "../styles/mui/fontWeight";

export enum DocumentUploadActionDispatchTypes {
  DOCUMENT_UPLOAD_RESET = "DOCUMENT_UPLOAD_RESET",
  DOCUMENT_UPLOAD_INVOKE = "DOCUMENT_UPLOAD_INVOKE",
  DOCUMENT_UPLOAD_SUCCESS = "DOCUMENT_UPLOAD_SUCCESS",
}

export enum DocumentType {
  PDF = "pdf",
  DOC = "msword",
  DOCX = "vnd.openxmlformats-officedocument.wordprocessingml.document",
  PNG = "png",
  JPEG = "jpeg",
  JPG = "jpg",
  INVALID = "",
}

export const DocumentAttachements = [
  "MD, DO, DPM, NP or PA Home Healthcare signed/verbal order (required)",
  "Supporting Clinical Documentation (required)",
];

export const ApplicableDocuments = [
  "H&P",
  "Inpatient Discharge Summary",
  "Notes from Hospital or SNF (including any therapy notes)",
  "MD Office Notes",
  "Wound Care Notes with Measurements",
];

export const CharacterCount = (characterCount: any) => {
  return (
      <Box
          sx={{
              display: "flex",
              justifyContent: "start",
              padding: "1rem 0 0 0rem",
          }}
      >
          <Typography
              variant="subtitle1"
              color={colors.black[1]}
              fontWeight={fontWeight[4]}
          >
              {250 - characterCount}
          </Typography>
          <Typography
              variant="subtitle1"
              color={colors.fonts[4]}
              fontWeight={fontWeight[3]}
              ml={"0.2rem"}
          >
              characters remaining
          </Typography>
      </Box>
  );
}; 
